import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';

export interface ITratamientoMinimizadoInfo {
  titulo: string;
  subtitulo?: string;
}

const ANIMATION_MS = 380;

@Injectable({ providedIn: 'root' })
export class TratamientoMinimizadoService {
  private dialogRefSubject = new BehaviorSubject<MatDialogRef<any> | null>(
    null,
  );
  private infoSubject = new BehaviorSubject<ITratamientoMinimizadoInfo | null>(
    null,
  );
  private animationTimeout?: ReturnType<typeof setTimeout>;

  public dialogRef$ = this.dialogRefSubject.asObservable();
  public info$ = this.infoSubject.asObservable();

  get isMinimizado(): boolean {
    return !!this.dialogRefSubject.value;
  }

  get info(): ITratamientoMinimizadoInfo | null {
    return this.infoSubject.value;
  }

  minimizar(ref: MatDialogRef<any>, info: ITratamientoMinimizadoInfo): void {
    clearTimeout(this.animationTimeout);

    // Registrar de inmediato para que el botón aparezca en la barra
    this.dialogRefSubject.next(ref);
    this.infoSubject.next(info);

    // Arrancar animación de salida hacia la esquina superior derecha
    ref.addPanelClass('tratamiento-minimizando');

    // Al terminar la animación, ocultar el panel
    this.animationTimeout = setTimeout(() => {
      ref.removePanelClass('tratamiento-minimizando');
      ref.addPanelClass('tratamiento-minimizado');
    }, ANIMATION_MS);
  }

  restaurar(): void {
    clearTimeout(this.animationTimeout);
    const ref = this.dialogRefSubject.value;
    if (!ref) return;

    // Quitar el estado de inmediato (botón desaparece de la barra)
    this.dialogRefSubject.next(null);
    this.infoSubject.next(null);

    // Mostrar el panel y arrancar animación de entrada
    ref.removePanelClass('tratamiento-minimizado');
    ref.addPanelClass('tratamiento-restaurando');

    // Al terminar la animación, quitar la clase
    this.animationTimeout = setTimeout(() => {
      ref.removePanelClass('tratamiento-restaurando');
    }, ANIMATION_MS);
  }

  cerrar(): void {
    clearTimeout(this.animationTimeout);
    const ref = this.dialogRefSubject.value;
    if (ref) {
      ref.removePanelClass('tratamiento-minimizando');
      ref.removePanelClass('tratamiento-minimizado');
      ref.removePanelClass('tratamiento-restaurando');
    }
    this.dialogRefSubject.next(null);
    this.infoSubject.next(null);
  }
}
